import { Fragment, useContext } from 'react';
import LoggedInAvatar from '../layout/LoggedInAvatar';
import AuthContext from '../../contexts/auth/AuthContext';

export const LoginMenu = () => {
  const { isAuthenticated, userInformation, signOut } = useContext(AuthContext);
  const authenticatedView = () => (
    <Fragment>
      {userInformation && (
        <LoggedInAvatar givenName={userInformation?.firstName} familyName={userInformation?.lastName} signOut={signOut} />
      )}
    </Fragment>
  );

  const unauthenticatedView = () => <Fragment />;

  return isAuthenticated ? authenticatedView() : unauthenticatedView();
};
